import { render, staticRenderFns } from "./AllegatiFascicolo.vue?vue&type=template&id=ab710c8c&"
import script from "./AllegatiFascicolo.vue?vue&type=script&lang=js&"
export * from "./AllegatiFascicolo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports